import { render, staticRenderFns } from "./AuthorImage.vue?vue&type=template&id=d6742bd8"
import script from "./AuthorImage.vue?vue&type=script&lang=ts"
export * from "./AuthorImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports